import renderAndEnableListingTiles from '../listing_tile_rendering/listingTileRenderer'
import { initiateSimilarSearch, buildFilters } from '../../utils/search/helpers'
import { onVisible } from '../utils'

export default function initCrossCategoryModules () {
  const crossCategorySections = document.querySelectorAll('.vjs-algolia-cross-category-section')

  crossCategorySections.forEach(section => {
    if (section.dataset.lazyLoaded === 'true') {
      onVisible(section, loadCrossCategoryListings)
    } else {
      loadCrossCategoryListings(section)
    }
  })
}

function loadCrossCategoryListings (section) {
  const {
    listingId, listingTitle, crossCategory, crossCategoryLvl0Names, vibeNames
  } = section.dataset
  const filters = buildFilters({ listingId, crossCategory, crossCategoryLvl0Names, vibeNames })
  const hitsPerPage = 20

  initiateSimilarSearch(listingTitle, hitsPerPage, filters).then(results => {
    const queryID = results.queryID ? results.queryID : ''
    results.hits.forEach((hit, index) => {
      hit.__position = index + 1
      hit.__queryID = queryID
    })
    renderSection(results, section)
  })
}

function renderSection (algoliaResults, section) {
  const { hitsPerPage } = section.dataset
  const hits = algoliaResults.hits.slice(0, hitsPerPage)

  renderAndEnableListingTiles(section, hits)
  import(/* webpackChunkName: "carousels" */ '../carousels').then(module => module.initPDPViewMoreCarousel(section))
}
